const deutsch = {
};

export default deutsch;